// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/views/bo-core/welcome/welcome.css
// module id = 787
// module chunks = 1